import * as yup from 'yup'
import { isValidDocumentCPF, isPasswordValid } from 'utils/tsfRegex'
import { isInvalidPhone, isValidBirthDate, isEmailValid } from 'utils'
import { DEFAULT_REQUIRED_MESSAGE } from 'src/utils'

yup.setLocale({
  mixed: {
    required: DEFAULT_REQUIRED_MESSAGE
  }
})

export const validateSchema = ({ isIncompleteRegister }) => {
  return (
    yup.object().shape({
      nameClient: yup.string().required(),
      documentCpf: yup.string().required().test('cpf-validation', 'CPF inválido', value => isValidDocumentCPF(value)),
      birthDate: yup.string().required().test('birth-date-validation', 'Data inválida', value => isValidBirthDate(value)),
      phone: yup.string().required().test('phone-validation', 'Telefone inválido', value => !isInvalidPhone(value)),
      email: yup.string().required().email('Email inválido').test('email-validation', 'Email inválido', value => isEmailValid(value)),
      password: !isIncompleteRegister && yup.string().required().min(8, 'A senha deve ter pelo menos 8 caracteres').test('password-validation', 'A senha deve conter letras maiúsculas, minúsculas, números e caracteres especiais', value => isPasswordValid(value)),
      confirmPassword: !isIncompleteRegister && yup.string().required().oneOf([yup.ref('password'), null], 'As senhas não conferem'),
      isMktsrvTermsAccepted: yup.boolean().oneOf([true], 'Os termos de uso devem ser aceitos')
    })
  )
}
